import React, { useState } from 'react';
import { useAppSelector, useAppDispatch } from '../../redux/hooks';
import { forgotPasswordRequest } from '../../redux/slices/authSlice';
import snapmenuLogo from '../../assets/snapmenu.png';

export const ForgotPassword: React.FC = () => {
  const dispatch = useAppDispatch();
  const { forgotPassword } = useAppSelector(state => state.auth);
  const [email, setEmail] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (email) {
      dispatch(forgotPasswordRequest({ email, type: "docs" }));
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-6">
      <div className="w-full max-w-md">
        {/* Forgot Password Card */}
        <div className="bg-white rounded-2xl shadow-xl overflow-hidden">
          {/* Logo/Header Section */}
          <div className="px-8 py-8 text-center">
            <div className="flex justify-center mb-6">
              <img 
                src={snapmenuLogo} 
                alt="SnapMenuAI Logo" 
                className="h-16 object-contain"
              />
            </div>
            <h2 className="text-2xl font-bold text-gray-900 mb-2">Forgot Password</h2>
          </div>

          {/* Form Section */}
          <div className="px-8 pb-8">
            <form onSubmit={handleSubmit} className="space-y-6">
              <div>
                <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2">
                  Email Address *
                </label>
                <input
                  id="email"
                  type="email"
                  placeholder="Enter your email address"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-1 focus:ring-red-500 focus:border-red-500"
                />
              </div>

              {/* Error Message */}
              {forgotPassword?.error && (
                <div className="bg-red-50 rounded-lg p-3">
                  <p className="text-red-700 text-sm">{forgotPassword.error}</p>
                </div>
              )}

              {/* Success Message */}
              {forgotPassword?.message && (
                <div className="bg-green-50 rounded-lg p-3">
                  <p className="text-green-700 text-sm">{forgotPassword.message}</p>
                </div>
              )}

              <button
                type="submit"
                disabled={forgotPassword?.loading || !email}
                className="w-full bg-red-500 text-white py-3 px-4 rounded-lg font-medium hover:bg-red-600 focus:outline-none disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
              >
                {forgotPassword?.loading ? 'Sending...' : 'Send Reset Link'}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};
